export const pageList = [
  {
    index: 0,
    name: 'about',
    videoPath: 'https://dev-sso-tt.s3.eu-central-1.amazonaws.com/resources/video/about-bg.mp4',
    bgImgPath: 'https://dev-sso-tt.s3.eu-central-1.amazonaws.com/resources/img/about-body-bg.jpg',
  },
  {
    index: 1,
    name: 'what_is',
    videoPath: 'https://dev-sso-tt.s3.eu-central-1.amazonaws.com/resources/video/what-is-bg.mp4',
    bgImgPath: 'https://dev-sso-tt.s3.eu-central-1.amazonaws.com/resources/img/what-is-body-bg.jpg',
  },
  {
    index: 2,
    name: 'what_is_1',
    videoPath: 'https://dev-sso-tt.s3.eu-central-1.amazonaws.com/resources/video/what-is-bg.mp4',
    bgImgPath: 'https://dev-sso-tt.s3.eu-central-1.amazonaws.com/resources/img/what-is-body-bg.jpg',
  },
  {
    index: 3,
    name: 'who_needs',
    videoPath: 'https://dev-sso-tt.s3.eu-central-1.amazonaws.com/resources/video/who-needs-bg.mp4',
    bgImgPath:
      'https://dev-sso-tt.s3.eu-central-1.amazonaws.com/resources/img/who-needs-body-bg.jpg',
  },
  {
    index: 4,
    name: 'who_needs_1',
    videoPath: 'https://dev-sso-tt.s3.eu-central-1.amazonaws.com/resources/video/who-needs-bg.mp4',
    bgImgPath:
      'https://dev-sso-tt.s3.eu-central-1.amazonaws.com/resources/img/who-needs-body-bg.jpg',
  },
  {
    index: 5,
    name: 'who_needs_2',
    videoPath: 'https://dev-sso-tt.s3.eu-central-1.amazonaws.com/resources/video/who-needs-bg.mp4',
    bgImgPath:
      'https://dev-sso-tt.s3.eu-central-1.amazonaws.com/resources/img/who-needs-body-bg.jpg',
  },
  {
    index: 6,
    name: 'who_created',
    videoPath:
      'https://dev-sso-tt.s3.eu-central-1.amazonaws.com/resources/video/who-created-bg.mp4',
    bgImgPath:
      'https://dev-sso-tt.s3.eu-central-1.amazonaws.com/resources/img/who-created-body-bg.jpg',
  },
  {
    index: 7,
    name: 'who_created_1',
    videoPath:
      'https://dev-sso-tt.s3.eu-central-1.amazonaws.com/resources/video/who-created-bg.mp4',
    bgImgPath:
      'https://dev-sso-tt.s3.eu-central-1.amazonaws.com/resources/img/who-created-body-bg.jpg',
  },
  {
    index: 8,
    name: 'why',
    videoPath: 'https://dev-sso-tt.s3.eu-central-1.amazonaws.com/resources/video/why-bg.mp4',
    bgImgPath: 'https://dev-sso-tt.s3.eu-central-1.amazonaws.com/resources/img/why-body-bg.jpg',
  },
  {
    index: 9,
    name: 'why_1',
    videoPath: 'https://dev-sso-tt.s3.eu-central-1.amazonaws.com/resources/video/why-bg.mp4',
    bgImgPath: 'https://dev-sso-tt.s3.eu-central-1.amazonaws.com/resources/img/why-body-bg.jpg',
  },
  {
    index: 10,
    name: 'supports',
    videoPath: 'https://dev-sso-tt.s3.eu-central-1.amazonaws.com/resources/video/sdgs-bg.mp4',
    bgImgPath: 'https://dev-sso-tt.s3.eu-central-1.amazonaws.com/resources/img/sdgs-body-bg.jpg',
  },
  {
    index: 11,
    name: 'supports_1',
    videoPath: 'https://dev-sso-tt.s3.eu-central-1.amazonaws.com/resources/video/sdgs-bg.mp4',
    bgImgPath: 'https://dev-sso-tt.s3.eu-central-1.amazonaws.com/resources/img/sdgs-body-bg.jpg',
  },
  {
    index: 12,
    name: 'gateway',
    videoPath:
      'https://dev-sso-tt.s3.eu-central-1.amazonaws.com/resources/video/the-gateway-bg.mp4',
    bgImgPath:
      'https://dev-sso-tt.s3.eu-central-1.amazonaws.com/resources/img/the-gateway-body-bg.jpg',
  },
  {
    index: 13,
    name: 'gateway_1',
    videoPath:
      'https://dev-sso-tt.s3.eu-central-1.amazonaws.com/resources/video/the-gateway-bg.mp4',
    bgImgPath:
      'https://dev-sso-tt.s3.eu-central-1.amazonaws.com/resources/img/the-gateway-body-bg.jpg',
  },
  {
    index: 14,
    name: 'gateway_2',
    videoPath:
      'https://dev-sso-tt.s3.eu-central-1.amazonaws.com/resources/video/the-gateway-bg.mp4',
    bgImgPath:
      'https://dev-sso-tt.s3.eu-central-1.amazonaws.com/resources/img/the-gateway-body-bg.jpg',
  },
];
